import type { IconProps } from './types';
import './icons.css';

export default function PermissionDenied({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 44}
      height={height || 56}
      viewBox="0 0 44 56"
      className={`icon icon-arrow-up ${className || ''}`}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 20.016V16C4 7.168 12.064 0 22 0s18 7.168 18 16v4.016c2.24.184 4 1.9 4 3.984v28c0 2.208-1.972 4-4.4 4H4.4C1.972 56 0 54.208 0 52V24c0-2.084 1.76-3.8 4-3.984ZM26.4 36c0-2.208-1.972-4-4.4-4-2.428 0-4.4 1.792-4.4 4v4c0 2.208 1.972 4 4.4 4 2.428 0 4.4-1.792 4.4-4v-4ZM32 20v-4c0-4.416-5.032-8-10-8s-10 3.584-10 8v4h20Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
